import { useTiltCard } from "./hooks";

/** <DepthCard> — any card gains full premium depth (lift, 4° tilt, mouse
 *  follow, dynamic shadow + gold glow, smooth return). Renders `as` tag. */
export default function DepthCard({ as: Tag = "div", maxDeg = 4, className = "", children, ...rest }) {
    const ref = useTiltCard(maxDeg);
    return (
        <Tag ref={ref} className={`will-change-transform ${className}`} {...rest}>
            {children}
        </Tag>
    );
}
